import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showSuccess } from "../../toaster/store/slice";
import bookingPricingSlice from "./slice";

type PricingResponse = ApiResponse<{ success: boolean }>;

function* bookingPricingSaga() {
  yield takeLatest(bookingPricingSlice.actions.request, handleRequest);
}

function* handleRequest({ payload: id }: PayloadAction<number>) {
  const response: PricingResponse = yield call(
    fetchAPI,
    `/bookings/${id}/pricing`,
    {
      method: HttpMethod.POST,
    }
  );

  if (response && response.success) {
    yield put(showSuccess("Pricing requested."));
  }

  yield put(bookingPricingSlice.actions.setIsLoading(false));
}

export default bookingPricingSaga;
